import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
// Allows for dynamic configurations at runtime
import { AppConfigService } from './services/app-config/app-config.service';

// Angular Material Modules
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';

import { appRoutes } from './app.routes';
import { AppComponent } from './app.component';
import { CapabilityRequestComponent } from './capability-request/capability-request.component';
import { BlobUploadService } from './services/blob-upload/blob-upload.service';
import { FormService } from './services/form/form.service';
import { LoaderService } from './services/loader/loader.service';
import { ConfirmationComponent } from './confirmation/confirmation.component';

const appConfigFactory = (appConfigService: AppConfigService) => {
  return () => appConfigService.setAppConfig();
};

@NgModule({
  declarations: [
    AppComponent,
    CapabilityRequestComponent,
    ConfirmationComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    MatToolbarModule,
    MatStepperModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatRadioModule,
    MatCheckboxModule,
    MatStepperModule,
    MatSnackBarModule,
    FlexLayoutModule,
    MatButtonModule,
    appRoutes
  ],
  providers: [
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appConfigFactory,
      deps: [ AppConfigService ],
      multi: true
    },
    BlobUploadService,
    FormService,
    LoaderService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
